import { CommonModule } from '@angular/common';
// Modules
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import * as i0 from "@angular/core";
export class TopBarNavAutocompleteModule {
}
TopBarNavAutocompleteModule.ɵfac = function TopBarNavAutocompleteModule_Factory(t) { return new (t || TopBarNavAutocompleteModule)(); };
TopBarNavAutocompleteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TopBarNavAutocompleteModule });
TopBarNavAutocompleteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule, CommonModule] });
